import React from "react";

function NotPage() {
  return <div>There's nothing here!</div>;
}

export default NotPage;